import React, { useEffect, useState } from 'react'
// import './similartaskdetail.scss'
import Modal from 'react-bootstrap/Modal';
import Pagination from 'react-bootstrap/Pagination';
import Navbar from '../landing/header/Navbar';
import { Link, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import { API_URL } from '../../utils/ApiUrl';
import { useWeb3React } from "@web3-react/core";
import Timer from '../landing/LatestTask/Timer';
import TaskTimer from '../Similartaskdetail/TaskTimer';
// import SimilarTasks from './SimilarTasks';
import copy from 'copy-to-clipboard';
// import { toast } from 'react-toastify';
import Loader from '../../hooks/loader';
// import TaskTimer1 from './TaskTimer1';
import { useLocation, useNavigate } from 'react-router-dom';
import { tokenImages } from '../../constants/tokenImages';
import CustomToast from '../../components/CustomToast';


const PerviewTask = () => {
    const [loader, setLoader] = useState(false);
    const { account } = useWeb3React();
    const [userId, setUserId] = useState(0);
    const [isCopied, setIsCopied] = useState(false);
    const [uniqueCode, setUniqueCode] = useState(null);
    const [uniqueStatus, setUniqueStatus] = useState(null);
    const { id } = useParams(); // Get the task ID from the URL
    const [taskData, setTaskData] = useState(null); // State for storing fetched task data
    const navigate = useNavigate();;
    // const [name, setName]=useState(null);
    const [data, setData] = useState(null)
    const [show, setShow] = useState(false);
    const [bool, setBoolean] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [taskIds, setTaskIds] = useState()
    const [show1, setShow1] = useState(false);
    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const [message, setMessage] = useState('');
    const [file, setFile] = useState(null);
    const [filePreview, setFilePreview] = useState('');
    const [apiReload, setApiReload] = useState(false)
    const location = useLocation();
    // const { filteredTaskData } = location.state || {};
    const { filteredTaskData } = location.state || {};
    const [disputeChec, setDisputeCheck] = useState(false)
    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [show3, setShow3] = useState(false);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [show4, setShow4] = useState(false);
    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);
    // console.log(taskData, filteredTaskData, 'taskData');
    const [show5, setShow5] = useState(false);
    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);
    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);


    const [show22, setShow22] = useState(false);

    const handleClose22 = () => setShow22(false);
    const handleShow22 = () => setShow22(true);
    // const tokenImages = {
    //     ETH: "/assets/createtask/eth.svg",
    //     USDT: "/assets/createtask/usdtT.svg",
    //     USDC: "/assets/createtask/usdc.svg",
    //     LINK: "/assets/createtask/link.svg",
    //     PEPE: "/assets/createtask/pepe.svg",
    //     UNI: "/assets/createtask/uni.svg",
    //     DOP: "/assets/createtask/dop1.svg",
    //     WBTC: "/assets/createtask/wbtc.svg",
    //     Tomi: '/assets/createtask/tomi.svg'
    // };
    const onClickCopy = async (txt) => {
        try {
            copy(txt);
            setIsCopied(true);
            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    async function participate() {
        handleClose();
        setLoader(true);
        try {
            // Get the accessToken from localStorage
            const accessToken = localStorage.getItem('accessToken');

            // Set up the config with headers
            const config = {
                headers: {
                    Authorization: `Bearer ${accessToken}` // Add the token to the Authorization header
                }
            };

            // Prepare the data you want to send in the POST request (optional)
            const data = {
                taskId: taskIds
            };

            // Make the POST request
            const response = await axios.post(`${API_URL}participants`, data, config);
            // // console.log(response?.data?.data, 'response?.data');
            setUniqueCode(response?.data?.data?.uniqueCode)
            setUniqueStatus(response?.data?.data?.status)
            setLoader(false);
            handleShow1();
            // Handle the response (success)
            // // console.log('Participation successful:', response.data);
        } catch (error) {
            // Handle any errors
            setLoader(false);
            // toast.error("Something went wrong");
             CustomToast.show('error', 'Error!', 'Something went wrong')
            console.error('Error participating in task:', error);
        }
    }
    const handleFileChange = (event) => {
        const selectedFile = event.target.files?.[0];
        if (selectedFile) {
            const fileType = selectedFile.type;
            // Ensure the file type is valid
            if (
                ['application/pdf', 'text/plain', 'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'image/jpeg', 'image/png', 'image/gif'].includes(fileType)
            ) {
                setFile(selectedFile);
                setFilePreview(URL.createObjectURL(selectedFile)); // Create a URL for the file preview
            } else {
                // toast.error('Unsupported file type. Please upload a PDF, TEXT, DOC, or DOCX file.');
                CustomToast.show('error', 'Error!', 'Unsupported file type. Please upload a PDF, TEXT, DOC, or DOCX file.')
                
            }
        }
    };

    // const handleSubmit = async () => {
    //     if (!file || !message) {
    //         toast.warn('Please fill in the message and select a file.');
    //         return;
    //     }
    //     let accessToken = localStorage.getItem('accessToken');
    //     setLoader(true);
    //     // Step 1: Upload the file to get the URL or an error
    //     let uploadedImageResponse = await imgeUrl(file); // Call the function to upload the image and get the URL or error

    //     // Step 2: Check if the response contains an error
    //     if (uploadedImageResponse && uploadedImageResponse.error) {
    //         toast.error(`Failed to upload the file: ${uploadedImageResponse.error}`);
    //         setLoader(false);
    //         return;
    //     }

    //     // If no error, get the uploaded image URL
    //     let uploadedImageUrl = uploadedImageResponse;

    //     // Step 3: Prepare data for the PATCH request
    //     const dataToSubmit = {
    //         taskId: id,
    //         message: message,
    //         uniqueCode: uniqueCode, // Replace with the actual unique code if it's dynamic
    //         proofOfWork: [uploadedImageUrl], // Add the uploaded image URL to this array
    //     };

    //     try {
    //         // Replace 'your-api-endpoint' with the actual endpoint
    //         await axios.patch(`${API_URL}participants`, dataToSubmit, {
    //             headers: {
    //                 'Content-Type': 'application/json', // Use application/json since we are sending a JSON object
    //                 'Authorization': `Bearer ${accessToken}`
    //             },
    //         });
    //         setBoolean('adfasf');
    //         handleClose2(); // Close modal after successful submission
    //         handleShow3();
    //         setLoader(false);
    //     } catch (error) {
    //         // Log detailed error response if available
    //         if (error.response) {
    //             console.error('API Error:', error.response.data.message || error.response.data);
    //             setLoader(false);
    //             toast.error(`Error submitting task: ${error.response.data.message || 'Unknown error'}`);
    //         } else {
    //             console.error('Error submitting the task:', error);
    //             setLoader(false);
    //             toast.error('Failed to submit the task. Please try again.');
    //         }
    //     }
    // };



    // const handleSubmitDispute = async () => {
    //     if (!file || !message) {
    //         toast.warn('Please fill in the message and select a file.');
    //         return;
    //     }
    //     let accessToken = localStorage.getItem('accessToken');
    //     setLoader(true);
    //     // Step 1: Upload the file to get the URL or an error
    //     let uploadedImageResponse = await imgeUrl(file); // Call the function to upload the image and get the URL or error

    //     // Step 2: Check if the response contains an error
    //     if (uploadedImageResponse && uploadedImageResponse.error) {
    //         toast.error(`Failed to upload the file: ${uploadedImageResponse.error}`);
    //         setLoader(false);
    //         return;
    //     }

    //     // If no error, get the uploaded image URL
    //     let uploadedImageUrl = uploadedImageResponse;

    //     // Step 3: Prepare data for the PATCH request
    //     const dataToSubmit = {
    //         message: message, // Replace with the actual unique code if it's dynamic
    //         proofOfWork: [uploadedImageUrl], // Add the uploaded image URL to this array
    //     };

    //     try {
    //         // Replace 'your-api-endpoint' with the actual endpoint
    //         await axios.post(`${API_URL}tasks/${id}/dispute`, dataToSubmit, {
    //             headers: {
    //                 'Content-Type': 'application/json', // Use application/json since we are sending a JSON object
    //                 'Authorization': `Bearer ${accessToken}`
    //             },
    //         });
    //         setBoolean('adfasf');
    //         // toast.success('File submitted successfully!');
    //         handleClose2(); // Close modal after successful submission
    //         handleShow5()
    //         setLoader(false);
    //         setApiReload(true)
    //     } catch (error) {
    //         // Log detailed error response if available
    //         if (error.response) {
    //             console.error('API Error:', error.response.data.message || error.response.data);
    //             setLoader(false);
    //             toast.error(`Error submitting task: ${error.response.data.message || 'Unknown error'}`);
    //         } else {
    //             console.error('Error submitting the task:', error);
    //             setLoader(false);
    //             toast.error('Failed to submit the task. Please try again.');
    //         }
    //     }
    // };


    // Updated imgeUrl function to return the URL
    // const imgeUrl = async (e) => {
    //     // // console.log(e, 'e');
    //     let accessToken = localStorage.getItem('accessToken');

    //     // Create a FormData object to send the image
    //     let formData = new FormData();
    //     formData.append('image', e);  // Assuming 'e' is the image file

    //     const config = {
    //         method: "post",
    //         url: `${API_URL}metadata/upload-image`,
    //         headers: {
    //             'Content-Type': 'multipart/form-data',  // Correct content type for file uploads
    //             'Authorization': `Bearer ${accessToken}`
    //         },
    //         data: formData,  // Send formData with the image file
    //     };

    //     try {
    //         let response = await axios(config);
    //         if (response) {
    //             // // console.log(response.data.url, 'response');
    //             return response.data.url; // Return the URL for further processing
    //         }
    //     } catch (error) {
    //         // Extract the error message from the API response and return it
    //         if (error.response) {
    //             const apiErrorMessage = error.response.data.message || error.response.data;
    //             console.error('API Error:', apiErrorMessage);
    //             return { error: apiErrorMessage }; // Return an object containing the error message
    //         } else {
    //             console.error('Error occurred while uploading image:', error);
    //             return { error: 'An unknown error occurred while uploading the image.' }; // Return a default error message
    //         }
    //     }
    // };

    const getProfile = async () => {
        let accessToken = localStorage.getItem('accessToken')
        var config = {
            method: "get",
            url: `${API_URL}users`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`  // Include the access token here
            },

        }
        try {
            let response = await axios(config)

            if (response) {
                setData(response.data.data)
            }
        } catch (error) {

        }
    }

    const handleButtonClick = () => {
        if (taskData?.editId) {
            // Uses React Router, replaces history, and no reload
            navigate(`/createtask?edit=${taskData.editId}&createTask=true`, { replace: true });
        } else {
            navigate(`/createtask`, { state: { createTask: true } });   
        }
    };


    // Fetch data when component mounts
    useEffect(() => {
        // Call the function
        setTaskData(filteredTaskData)
        getProfile()
        window.scrollTo(0, 0); // Scroll to top
    }, [filteredTaskData]);
    useEffect(() => {
        const fetchTaskData = async () => {
            try {
                // Get the accessToken from localStorage
                const accessToken = localStorage.getItem('accessToken');

                // Set up the config with headers
                // Set up the config with headers conditionally
                const config = accessToken
                    ? { headers: { Authorization: `Bearer ${accessToken}` } }
                    : {}; // If no token, leave headers empty

                // Make the API request with the Authorization header
                const secretCodeResponse = await axios.get(`${API_URL}participants/unique-code/${id}`, config);
                // // console.log(secretCodeResponse, 'secretCodeResponse');
                setUniqueStatus(secretCodeResponse?.data?.data?.status)
                // Store the fetched data in the state
                setUniqueCode(secretCodeResponse?.data?.data?.uniqueCode);
            } catch (error) {
                console.error("Error fetching task data:", error);
            }
        };
        let userId = localStorage.getItem('userId');
        setUserId(userId)
        fetchTaskData(); // Call the function
        window.scrollTo(0, 0); // Scroll to top
    }, [id, bool]);
    // // console.log(uniqueStatus, uniqueStatus, 'uniqueStatus');

    const errorMsg = () => {
        // toast.error("Connect Wallet!")
        CustomToast.show('error', 'Error!', 'Connect Wallet!')
    };
    // console.log(taskData, 'taskData');

    return (
        <>
            {loader && <Loader />}
            {/* <Navbar /> */}
            <section className="similartaskdetail">
                <img src="/assets/importantassets/backshade.png" alt="backshade" className="backshade" />
                <img src="/assets/importantassets/backshadembl.png" alt="backshade" className="backshadembl d-none" />
                <div className="custom-container">

                    <div className="detailmain">
                        <div className="detailsleft">
                            {/* <span className="statusmain">
                                <span className="statuscircle"></span>
                                <p className="statuspara">PARTICIPATED</p>
                            </span> */}
                            <h4 className="detailhead">{taskData?.title}</h4>
                            <div className='d-flex'>
                                {taskData?.serviceType === 'physical' && <div className='formate'>

                                    <h3 className='formatehead '>Location</h3>
                                    <div className='mainbuttons me-3'>
                                        <button className='button2'>{taskData?.selectedCountry},{taskData?.selectedCity} </button>

                                    </div>
                                </div>}
                                {taskData?.deliveryFormat?.length > 0 && <div className='formate'>

                                    <h3 className='formatehead '>Delivery Format</h3>
                                    <div className='mainbuttons '>
                                        {taskData?.deliveryFormat?.map((item) => <button>{item}</button>)}
                                    </div>
                                </div>}
                            </div>

                            {/* <p className="detailpara">{taskData?.description}</p> */}
                            <div className='mainheadingggg'>
                                <h2>Task Details</h2>
                            </div>
                            <div
                                className="detailpara ql-editor-new"
                                // Uncomment the next line if using DOMPurify
                                // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                                dangerouslySetInnerHTML={{ __html: taskData?.description }}
                            />
                            <div className='mainheadingggg'>

                            </div>
                            {taskData?.requirements && <>
                                <h2>Task Requirements</h2>
                                <div
                                    className="detailpara ql-editor-new"
                                    // Uncomment the next line if using DOMPurify
                                    // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                                    dangerouslySetInnerHTML={{ __html: taskData?.requirements }}
                                />
                            </>}
                            {taskData?.additionalRequest && <div className='mainheadingggg forbrdrrrrr'>
                                <h2>Additional Requests</h2>
                                <div
                                    className="detailpara ql-editor-new"
                                    // Uncomment the next line if using DOMPurify
                                    // dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                                    dangerouslySetInnerHTML={{ __html: taskData?.additionalRequest }}
                                />
                            </div>}

                        </div>
                        <div className="detailsright">
                            <div className="innerdetailsright">
                                <div className="detailtop">
                                    <div className="detailinnerleft">
                                        <p className="rewardpara">Reward</p>
                                        <div className="rewardamount">
                                            <div className="rewardimg">
                                                <img src={tokenImages[taskData?.currencySymbol]} alt="innerrewardimg" className="innerrewardimg" />
                                            </div>
                                            {taskData?.reward} {taskData?.currencySymbol}
                                        </div>
                                    </div>
                                    <div className="detailinnerright">
                                        <p className="participantpara">Submissions</p>
                                        <div className="partcipantmainhead">

                                            {/* <div className="participantmain one">
                                                <img src="/assets/dummyassets/dummyone.png" alt="participantimg" className="participantimg" />
                                            </div>
                                            <div className="participantmain two">
                                                <img src="/assets/dummyassets/dummytwo.png" alt="participantimg" className="participantimg" />
                                            </div>
                                            <div className="participantmain three">
                                                <img src="/assets/dummyassets/dummythree.png" alt="participantimg" className="participantimg" />
                                            </div>
                                            <div className="participantmain four">
                                                <img src="/assets/dummyassets/dummyfour.png" alt="participantimg" className="participantimg" />
                                            </div> */}
                                            {/* <div className="participantmain five"> */}
                                            <div className="participantmain ">
                                                <p className="numberimages">
                                                    0
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="detailinnerright">
                                        <p className="participantpara">Created By</p>
                                        <div className="creatormain">
                                            <div className={"creatormainimg"}>
                                                <img src={data?.imageUrl ? data?.imageUrl : '/assets/edituploadimg.png'} alt="img" className='creatorimg' />
                                            </div>
                                            <p className="creatorwallet">{data?.name ? data?.name : data?.walletAddress?.slice(0, 10)}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="maintimer">
                                    <p className="endpara">Ends in</p>
                                    {taskData?.participants?.[0]?.status === 'winner' ?
                                        <TaskTimer endTime={0} />
                                        :
                                        <TaskTimer endTime={taskData?.endTime} fetchTaskData={() => { }} />
                                    }
                                </div>
                                {/* <button className='participatebtn' >Participate</button> */}

                                <div className="text-center mt-4">
                                    {/* <a target="_blank" href={`https://etherscan.io/tx/${taskData?.taskTransactionHash}`}>      <img src="/assets/latesttask/explorer.svg" alt="" srcset="" /></a> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <SimilarTasks taskId={id} categoryId={taskData?.categoryId} handleShow={handleShow} /> */}
                <div className='endboxbuttons'>
                    <button onClick={() => taskData?.editId ? navigate(`/createtask?edit=${taskData?.editId}`) : navigate('/createtask')} className='edit'>Edit</button>
                    <button onClick={handleButtonClick} className='post'>
                        {taskData?.editId ? 'Save Changes' : 'Post Task'}
                    </button>
                </div>
            </section>
        </>
    )
}

export default PerviewTask